<template>
  <div id="main-footer">
    <label>RHALP © {{ currentYear }} - Todos os direitos reservados</label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
#main-footer {
  height: 60px;
  background-color: var(--bg-secondary);
  border-top: 2px solid var(--border-color);
  width: 100%;
  left: 0;
  bottom: 0;
  text-align: center;
  transition: var(--transition);
  z-index: 100;
}

label {
  margin-top: 15px;
  color: var(--text-primary);
  font-weight: 500;
  transition: var(--transition);
}
</style>
